<script setup lang="ts">
import IconX from '@/assets/icons/fill/x.svg?component';
import IconLine from 'theme/assets/icons/fill/line.svg?component';
import ButtonFlat from 'theme/components/atoms/ButtonFlat.vue';
import IconFacebook from 'theme/components/atoms/icons/IconFacebook.vue';

const props = defineProps<{
  pageTitle: string;
  pageUrl: string;
}>();

const alert = useAlert();

const shareOnX = () => {
  const searchParams = new URLSearchParams({
    text: props.pageTitle,
    url: props.pageUrl,
  });
  const shareWindowUrl = new URL('https://x.com/intent/tweet');
  shareWindowUrl.search = searchParams.toString();

  window.open(
    shareWindowUrl.toString(),
    '',
    'toolbar=no,location=yes,width=550,height=420'
  );
};

const shareOnFacebook = () => {
  const searchParams = new URLSearchParams({
    u: props.pageUrl,
  });
  const shareWindowUrl = new URL('https://facebook.com/share.php');
  shareWindowUrl.search = searchParams.toString();

  window.open(
    shareWindowUrl.toString(),
    '',
    'toolbar=no,location=yes,width=550,height=700'
  );
};

const shareOnLine = () => {
  const searchParams = new URLSearchParams({
    url: props.pageUrl,
  });
  const shareWindowUrl = new URL('https://social-plugins.line.me/lineit/share');
  shareWindowUrl.search = searchParams.toString();

  window.open(
    shareWindowUrl.toString(),
    '',
    'toolbar=no,location=yes,width=500,height=500'
  );
};

const copyURL = async () => {
  await navigator.clipboard
    .writeText(props.pageUrl)
    .catch(() => {
      alert.error(
        'URLのコピーに失敗しました。リロードをして再度お試しください。'
      );
    })
    .then(() => {
      alert.success('クリップボードにコピーしました');
    });
};
</script>

<template>
  <ul :class="$style.buttons">
    <li :class="[$style.buttons__item, $style['buttons__item--x']]">
      <ButtonFlat variant="base" :class="$style.shareButton" @click="shareOnX">
        <IconX :class="[$style.icon, $style['icon--x']]" />
        <span>シェア</span>
      </ButtonFlat>
    </li>
    <li :class="[$style.buttons__item, $style['buttons__item--facebook']]">
      <ButtonFlat
        variant="base"
        :class="$style.shareButton"
        @click="shareOnFacebook"
      >
        <IconFacebook :class="[$style.icon, $style['icon--facebook']]" />
        <span>シェア</span>
      </ButtonFlat>
    </li>
    <li :class="[$style.buttons__item, $style['buttons__item--line']]">
      <ButtonFlat
        variant="base"
        :class="$style.shareButton"
        @click="shareOnLine"
      >
        <IconLine :class="[$style.icon, $style['icon--line']]" />
        <span>シェア</span>
      </ButtonFlat>
    </li>
    <li :class="[$style.buttons__item, $style['buttons__item--copy']]">
      <ButtonFlat variant="base" :class="$style.shareButton" @click="copyURL"
        >URLをコピー</ButtonFlat
      >
    </li>
  </ul>
</template>

<style lang="scss" module>
.buttons {
  display: grid;
  margin: 0;
  padding: 0;
  gap: 8px;
  grid-template:
    'x  fb ln' 40px
    'cp cp cp' 40px;

  @include small-mobile-only {
    grid-template:
      'x' 40px
      'fb' 40px
      'ln' 40px
      'cp' 40px;
  }

  &__item {
    &--x {
      grid-area: x;
    }

    &--facebook {
      grid-area: fb;
    }

    &--line {
      grid-area: ln;
    }

    &--copy {
      grid-area: cp;
    }
  }
}

.shareButton {
  $root: &;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
  font-weight: bold;
  gap: 4px;
  padding-inline: 0px;

  width: 100%;
  height: 100%;
}

.icon {
  $icon-size: 16px;

  font-size: $icon-size;
  width: $icon-size;
  height: $icon-size;

  &--x {
    color: $color-third-party-x;
  }

  &--facebook {
    color: $color-third-party-facebook;
  }

  &--line {
    color: $color-third-party-line;
  }
}
</style>
